<template>
  <v-col :lg="lg" :md="md" :sm="sm" :cols="cols">
    <v-card class="reg-details-profile-card d-flex flex-column" flat tile
      :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
      <v-card-title class="pt-5 pb-5">
        <div v-if="isFirstCard" class="d-flex justify-space-between align-center w-100">
          <div>
            <span>{{ personalinfo?.fullname }}</span>
            <strong>{{ personalinfo?.id }}</strong>
          </div>
          <DropdownView></DropdownView>
        </div>
        <div v-else class="d-flex justify-space-between align-center w-100">
          <span>Personal Information</span>
          <v-dialog v-if="$canRoute('create-new-user-account') === 1" transition="scale-transition" origin="center center" max-width="760" v-model="dialogDeposit"
            content-class="deposit-withdraw-popup marketingPopup">
            <template v-slot:activator="{ on, attrs }">
              <span class="edit" v-bind="attrs" v-on="on">Edit</span>
            </template>
            <!-- Dialog content goes here -->
            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
              <v-card-title class="pb-3 text-left justify-start pl-3">
                Edit Personal Information
              </v-card-title>
              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                You Can Edit User’s Personal Info. From Here
              </v-card-subtitle>
              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>First Name</legend>
                      <v-text-field label="Ishak" v-model="editedInfo.firstName" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Zip Code</legend>
                      <v-text-field v-model="editedInfo.postal_code" label="Type your zip code" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Last Name</legend>
                      <v-text-field v-model="editedInfo.lastName" label="Type your last name" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Address</legend>
                      <v-text-field v-model="editedInfo.address" label="Type your address" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Email Address</legend>
                      <v-text-field v-model="editedInfo.email" label="Type your email" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Date Of Birth
                      </legend>
                      <input 
                        title="Please enter your date of birth" 
                        type="date" 
                        v-model="editedInfo.dob"
                        class="form-control custom-date-input" 
                        :max="new Date().toISOString().split('T')[0]" 
                      />
                      <small>
                        {{ editedInfo.dob && `Your date of birth: (${new Date(editedInfo.dob).toLocaleDateString()})`}}
                      </small>
                    </fieldset>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Owner Type</legend>
                      <v-select v-model="editedInfo.owner_type" solo :items="slots1" append-icon="mdi-chevron-down"
                        label="Click to Select" class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Contact No.</legend>
                      <v-text-field v-model="editedInfo.mobile" label="Type your contact no." single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Country</legend>
                      <v-select solo v-model="editedInfo.country" :items="countries" item-text="name" item-value="id"
                        @change="onCountryChange" append-icon="mdi-chevron-down" label="Select country"
                        class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>State</legend>
                      <v-select solo v-model="editedInfo.state" :items="states" item-text="name" item-value="id"
                        @change="onStateChange" append-icon="mdi-chevron-down" label="Select state"
                        class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>City</legend>
                      <v-select solo v-model="editedInfo.city" :items="cities" item-text="name" item-value="id"
                        @change="onCityChange" append-icon="mdi-chevron-down" label="Select city" class="custom-select"
                        hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset class="custom-textarea">
                      <legend>Comment</legend>
                      <v-textarea v-model="editedInfo.comment" label="Write Comment Here" single-line auto-grow solo
                        hide-details class="custom-select"></v-textarea>
                    </fieldset>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn tile @click="updatePersonalInfo" elevation="0"
                      class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Update</v-btn>
                    <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                      class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-card-text class="py-0 pr-0 d-flex align-center" v-if="isFirstCard">
          <v-avatar size="105" class="mr-6">
            <v-img
              :src="personalinfo?.profile_pic_url || `https://ui-avatars.com/api/?name=${personalinfo?.fullname}&background=random` || require('@/assets/user.png')"></v-img>
          </v-avatar>
          <div class="pa-0">
            <v-card-subtitle class="pa-0 mb-2">
              <span class="mdi mdi-email-outline mr-2"></span>
              <span>{{ personalinfo?.email || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2">
              <span class="mdi mdi-phone-in-talk-outline mr-2"></span>
              <span>{{ personalinfo?.mobile || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2">
              <span class="mdi mdi-map-marker-outline mr-2"></span>
              <span>{{ personalinfo?.address || "N/A" }}</span>
            </v-card-subtitle>
          </div>
        </v-card-text>
        <div v-else>
          <v-card-text class="py-0 pr-0 d-flex flex-wrap" style="overflow: hidden;">
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Country: </span>
              <span>{{ personalinfo?.countries?.name || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>City: </span>
              <span>{{ personalinfo?.cities?.name || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>State: </span>
              <span>{{ personalinfo?.states?.name || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Zip Code: </span>
              <span>{{ personalinfo?.postal_code || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Address: </span>
              <span class="truncate-text mr-2" :title="personalinfo?.address || 'N/A'">{{ personalinfo?.address || "N/A"
                }}</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-bind="attrs" v-on="on" @click="copyToClipboard(personalinfo?.address)">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copy Address</span>
              </v-tooltip>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Date of birth: </span>
              <span>{{ new Date(personalinfo.dob).toLocaleDateString() || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Reg. date: </span>
              <span>{{ formatMySQLDate(personalinfo?.created_at) || "N/A" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Owner type: </span>
              <span>{{ personalinfo?.owner_type === "1" ? "Individual" : "Company" }}</span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle flex-basis-50">
              <span>Comment: </span>
              <span class="truncate-text mr-2" :title="personalinfo?.comment || 'N/A'">{{ personalinfo?.comment || "N/A"
              }}</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-bind="attrs" v-on="on"
                    @click="copyToClipboard(personalinfo?.comment || 'No comment found')">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copy Comment</span>
              </v-tooltip>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0">
              <button @click="seeParents = true">
                <span class="text-capitalize" style="color: #039de9; font-size: 14px; text-decoration: underline;">See
                  All
                  Parents</span>
              </button>
              <v-dialog transition="scale-transition" origin="center center" max-width="480" v-model="seeParents"
                content-class="deposit-withdraw-popup">
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Parent List
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Parent List of <span class="text--green">{{ parentdescendants?.user?.name }} ({{
                      parentdescendants?.user?.id
                    }})</span>
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4 mt-5 mb-0"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <ul v-if="parentdescendants?.parents?.length > 0" class="partnerList">
                      <!-- Parent items -->
                      <li v-for="parent in parentdescendants?.parents" :key="parent.level">
                        <div class="label-text">
                          <span>Level {{ parent?.level }}</span>
                        </div>
                        <div :title="`Click here to see details for ${parent?.name}`"
                          @click="handleRedirectUser(`/registered-user-details/${parent?.id}`)" class="details-text"
                          style="cursor: pointer;  width: 300px;">
                          <v-avatar size="50">
                            <v-img
                              :src="parent?.profile_pic_url || `https://ui-avatars.com/api/?name=${parent?.name}&background=random` || require('@/assets/user.png')"></v-img>
                          </v-avatar>
                          <div class="user-details">
                            <div>{{ parent?.name?.length > 15 ? parent?.name?.substring(0, 15) + '...' : parent?.name }}
                              <p class="mb-0">(PARENT-{{ parent?.id }})</p>
                            </div>
                            <p class="mb-0">{{ obfuscateAnyEmail(parent?.email) }}</p>
                          </div>
                        </div>
                      </li>
                      <!-- Current user (me) -->
                      <li class="active">
                        <div class="label-text">
                          <span class="text--green">me</span>
                        </div>
                        <div :title="`Click here to see details for ${parentdescendants?.user?.name}`"
                          @click="handleRedirectUser(`/registered-user-details/${parentdescendants?.user?.id}`)"
                          class="details-text" style="cursor: pointer; width: 300px;">
                          <v-avatar size="50">
                            <v-img
                              :src="parentdescendants?.profile_pic_url || `https://ui-avatars.com/api/?name=${parentdescendants?.user?.name}&background=random` || require('@/assets/user.png')"></v-img>
                          </v-avatar>
                          <div class="user-details">
                            <div>{{ parentdescendants?.user?.name?.length > 15 ?
                              parentdescendants?.user?.name?.substring(0,
                                15) +
                              '...' : parentdescendants?.user?.name }}<p class="mb-0">(PARENT-{{
                                parentdescendants?.user?.id
                              }})</p>
                            </div>
                            <p class="mb-0">{{ obfuscateAnyEmail(parentdescendants?.user?.email) }}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <p v-else>No Parents Available</p>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile color="#FF567F" @click="seeParents = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Close</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-subtitle>
          </v-card-text>
        </div>
      </v-card-actions>
      <v-snackbar v-model="showCopyNotification" :timeout="2000" color="success" bottom>
        Text copied to clipboard!
      </v-snackbar>
    </v-card>
  </v-col>
</template>

<script>
import { formatMySQLDate } from '@/_helpers/formateDate';
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import {
  CITIES__ACTIONS,
  COUNTRIES__ACTIONS,
  REGISTERUSERDETAILS__ACTIONS,
  STATES__ACTIONS,
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import DropdownView from './DropdownView.vue';

export default {
  components: { DropdownView },
  props: {
    lg: {
      type: Number,
      default: 6,
    },
    md: {
      type: Number,
      default: 6,
    },
    sm: {
      type: Number,
      default: 12,
    },
    cols: {
      type: Number,
      default: 12,
    },
    isFirstCard: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      default: "",
    },
    userId: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    email: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    // personalInfo: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      showCopyNotification: false,
      seeParents: false,
      menu: false,
      dialogDeposit: false,
      modal: false,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      date: ["2022-01-01", "2023-01-01"],
      slots1: ["Company", "Individual",],
      slots2: ["BCC", "ACC", "NCC"],
      slots4: ["Bangladesh", "Soudi Arab", "Dubai", "Canada"],
      slots5: ["Dhaka", "Sylhet", "Rajshahi"],
      slots6: ["Kumarkhali", "Nouga", "Bagmara"],
      editedInfo: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        dob: null,
        country: '',
        state: '',
        city: '',
        postal_code: '',
        address: '',
        owner_type: '',
        comment: '',
      },
    };
  },

  computed: {
    ...mapState("reguserdetails", ["personalinfo", "parentdescendants"]),
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO, REGISTERUSERDETAILS__ACTIONS.UPDATEREGPERSONALINFO, REGISTERUSERDETAILS__ACTIONS.ACCOUNTDESCENDANTS]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),

    copyToClipboard(text) {
      if (!text) return;

      navigator.clipboard.writeText(text)
        .then(() => {
          this.showCopyNotification = true;
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    },

    populateEditForm() {
      const names = this.personalinfo?.fullname?.split(' ');
      this.editedInfo = {
        firstName: names[0] || '',
        lastName: names?.slice(1)?.join(' ') || '',
        email: this.personalinfo?.email,
        mobile: this.personalinfo?.mobile,
        dob: this.personalinfo?.dob || null,
        country: this.personalinfo?.countries?.id || "",
        state: this.personalinfo?.states?.id || "",
        city: this.personalinfo?.cities?.id || "",
        postal_code: this.personalinfo?.postal_code,
        address: this.personalinfo?.address,
        owner_type: this.personalinfo?.owner_type === "1" ? "Individual" : "Company",
        comment: this.personalinfo?.comment,
      };
    },

    handleRedirectUser(user) {
      window.location.href = user
    },

    async updatePersonalInfo() {
      const updatedInfo = {
        id: this.personalinfo?.id,
        fname: this.editedInfo.firstName.trim(),
        lname: this.editedInfo.lastName.trim(),
        email: this.editedInfo.email,
        mobile: this.editedInfo.mobile,
        dob: this.editedInfo.dob,
        country_id: this.editedInfo.country,
        state_id: this.editedInfo.state,
        city_id: this.editedInfo.city,
        postal_code: this.editedInfo.postal_code,
        address: this.editedInfo.address,
        owner_type: this.editedInfo.owner_type,
        comment: this.editedInfo.comment,
      };

      this[REGISTERUSERDETAILS__ACTIONS.UPDATEREGPERSONALINFO](updatedInfo);
      this.dialogDeposit = false;

      console.log(this.updatedInfo);
      console.log(this.personalinfo);

    },
    async onCountryChange(value) {
      this.editedInfo.country = value;
      this.editedInfo.state = null;
      this.editedInfo.city = null;
      await this[STATES__ACTIONS.STATES](value);
    },

    async onStateChange(value) {
      this.editedInfo.state = value;
      this.editedInfo.city = null;
      await this[CITIES__ACTIONS.CITIES](value);
    },

    onCityChange(value) {
      this.editedInfo.city = value;
    },


    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
  },

  async mounted() {
    const userId = this.$route.params.id;
    await this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](userId);
    await this[REGISTERUSERDETAILS__ACTIONS.ACCOUNTDESCENDANTS](userId);
    await this[COUNTRIES__ACTIONS.COUNTRIES]();
    this.populateEditForm();

    if (this.editedInfo.country) {
      await this[STATES__ACTIONS.STATES](this.editedInfo.country);
    }
    if (this.editedInfo.state) {
      await this[CITIES__ACTIONS.CITIES](this.editedInfo.state);
    }
  },

  watch: {
    personalinfo: {
      handler() {
        this.populateEditForm();
      },
      deep: true,
    },
  },
};

</script>
<style scoped>
.custom-date-input {
  width: 100%;
  padding: 2px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: transparent;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
}

/* Style for the date input placeholder */
.custom-date-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* Remove default calendar icon in some browsers */
.custom-date-input::-webkit-calendar-picker-indicator {
  background-color: rgba(255, 255, 255, 0.2);
  padding: 5px;
  cursor: pointer;
  border-radius: 3px;
}

.truncate-text {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
}

.listing-v-card__subtitle {
  position: relative;
}

/* Add styles for copy button */
.v-btn.v-btn--icon.v-size--x-small {
  width: 20px;
  height: 20px;
}

.v-btn.v-btn--icon.v-size--x-small .v-icon {
  font-size: 16px;
}
</style>
